import Axios, { AxiosInstance } from 'axios';

import { API_URL } from './config';
import { shouldRedirectToLogin } from './shouldRedirectToLogin';

export const setAxiosOnError = (handler: (error: any) => void) => {
  axiosOnError = handler;
};

let axiosOnError: (error: any) => void;

const buildHttpClient = ({ baseUrl = '' }): AxiosInstance => {
  const httpClient = Axios.create({
    baseURL: baseUrl,
    withCredentials: true
  });

  httpClient.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response?.status !== 401) {
        if (axiosOnError && !error.config?.skipGlobalErrorHandler) {
          axiosOnError(error);
        }
      } else {
        if (shouldRedirectToLogin(window.location.pathname, error?.request?.responseURL)) {
          window.location.href = '/login';
        }
      }
      return Promise.reject(error);
    }
  );

  return httpClient;
};

const mainDbAxiosClient = buildHttpClient({ baseUrl: API_URL });

export const getAxios = () => {
  return mainDbAxiosClient;
};
